<script setup>
import { computed } from 'vue'

const { stats } = defineProps({
  stats: {
    type: Object,
    default: () => ({})
  },
})

const isNew = computed(() => {
  return stats.timesInList == 1 || (!stats.timesInList && !stats.previousPosition) // Bug in database?
})

const isReEntry = computed(() => {
  return stats.timesInList > 1 && !stats.previousPosition
})

const movement = computed(() => {
  return stats.previousPosition - stats.position
})

const display = computed(() => {
  if (movement.value == 0) { return }
  return Math.abs(movement.value)
})

const styleClass = computed(() => {
  switch (Math.sign(movement.value)) {
    case -1:
      return 'movement--dropped'
    case 1:
      return 'movement--raised'
    default:
      return 'movement--equal'
  }
})

const iconSymbol = computed(() => {
  if (movement.value == 0) { return '=' }
  else if (movement.value > 0) { return '↑' }
  else { return '↓' }
})
</script>

<template>
  <span class="track-movement">
    <span v-if="isNew" class="movement-label movement--new">Nieuw</span>
    <span v-else-if="isReEntry" class="movement-label movement--reentry">Re-entry</span>
    <template v-else>
      <span class="movement-previous">{{ stats.previousPosition }}</span> | 
      <strong class="movement-value" :class="styleClass">
        <span class="movement-icon">{{ iconSymbol }}</span> {{ display }}
      </strong>
    </template>
  </span>
</template>

<style>
.track-movement {
  display: inline-block;
}

.movement-label {
  display: inline-block;
}

.movement-previous {
  display: inline-block;
}

.movement-value {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
}

.movement-icon {
  display: inline-block;
}

.movement--new {
  color: #4caf50;
}

.movement--reentry {
  color: #ff9800;
}

.movement--raised {
  color: #4caf50;
}

.movement--dropped {
  color: #f44336;
}

.movement--equal {
  color: #757575;
}
</style>